let productCategoryApi = {
    async get(token, companyId, params = {}) {
        let response = await window.axios.get('/api/categories', {
            params: {
                api_token: token,
                company_logged: companyId,
                ...params
            }
        });
        return response.data;
    },
}

export default productCategoryApi